/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Denah_S4Inputs */

const en_tut_denah_s4 = /** @type {(inputs: Tut_Denah_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Press **Simpan draft** to save with no effect at all. When you are sure, use **Tinjau penerbitan** and then **Terbitkan draft tersimpan**.`)
};

const id_tut_denah_s4 = /** @type {(inputs: Tut_Denah_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekan **Simpan draft** untuk menyimpan tanpa dampak apa pun. Kalau sudah yakin, **Tinjau penerbitan** lalu **Terbitkan draft tersimpan**.`)
};

/**
* | output |
* | --- |
* | "Press **Simpan draft** to save with no effect at all. When you are sure, use **Tinjau penerbitan** and then **Terbitkan draft tersimpan**." |
*
* @param {Tut_Denah_S4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_denah_s4 = /** @type {((inputs?: Tut_Denah_S4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Denah_S4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_denah_s4(inputs)
	return en_tut_denah_s4(inputs)
});